import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=c2b5583e&"
import script from "./ProfileItem.vue?vue&type=script&lang=js&"
export * from "./ProfileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports